import { useState } from 'react';

export default function BrowseGif({
  src,
  contained = false,
  isHighlighted = false,
}: {
  src: string;
  contained?: boolean;
  isHighlighted?: boolean;
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className="relative aspect-square w-full rounded-lg">
      {/* Loading placeholder - only show while loading */}
      {!isLoaded && !hasError && (
        <div className="bg-gray-15 dark:bg-gray-75 absolute inset-0 animate-pulse rounded-lg" />
      )}

      {/* Error placeholder - only show on error */}
      {hasError && (
        <div className="bg-gray-15 dark:bg-gray-75 absolute inset-0 flex items-center justify-center rounded-lg">
          <span className="dark:text-gray-40 text-sm text-gray-50">
            Failed to load
          </span>
        </div>
      )}

      <img
        src={src}
        className={`${isLoaded ? 'opacity-100' : 'opacity-0'} h-full w-full rounded-[inherit] transition-opacity duration-200 ${isHighlighted ? 'ring-blue ring-4' : ''}`}
        style={contained ? { objectFit: 'contain' } : { objectFit: 'cover' }}
        alt="" // Empty alt to prevent screen reader issues during loading
        draggable={false}
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
      />
    </div>
  );
}
